import { ReactNode } from 'react';

import styles from './table.module.css';

export type TableHeadCellProps = {
	children: ReactNode | ReactNode[];
};

export const TableHeadCell = ({ children }: TableHeadCellProps) => <th className={styles.headCell}>{children}</th>;
